module.exports = __webpack_public_path__ + "static/media/handRing.52c6e074.jpg";